import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';


export const PLButton = styled(BaseButton)`
    color: ${COLORS.TextWhite};
    background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%),
                linear-gradient(105.23deg, #B9CF31 15.62%, #FA00FF 106.65%);
`;
